import type { LangStrings } from './en';

export const es: LangStrings = {
  back: 'ATRÁS',
  next: 'SIGUIENTE',
  retry: 'REINTENTAR',
  replay: 'REJUGAR',
  sector: 'SECTOR',
  sectors: 'SECTORES',
  levels: 'NIVELES',
  cleared: 'COMPLETADO',
  open: 'ABIERTO',
  locked: 'BLOQUEADO',
  tba: 'TBA',
  slot_reserved: 'RESERVADO',
  sfx_on: 'SFX SÍ',
  sfx_off: 'SFX NO',
  reset_progress: 'BORRAR PROGRESO',
  wiped_reloading: 'BORRADO, RECARGANDO…',
  got_it: '› ENTENDIDO ‹',

  boot_eyebrow: 'PROTOCOLO CASCADA  //  BUILD',
  boot_tagline: 'UN TOQUE. UNA CASCADA. SIN REVANCHA.',
  boot_subtitle: '信号崩壊  ·  LÓGICA DE CASCADA',
  boot_cta: '› TOCA PARA INICIAR ‹',
  boot_region: 'REGIÓN ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // EN LÍNEA',

  menu_header_subtitle: 'NØDUS / SELECCIÓN.SECTOR',
  menu_engine_label: 'motor de colapso de señal',
  menu_signals_down: 'señales caídas',
  menu_tap_chapter: 'TOCA UN CAPÍTULO PARA ENTRAR',
  menu_language_label: 'IDIOMA',

  chapter_signals_down: 'señales caídas',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: 'CODA',
  chapter_coda_tagline: 'Nada nuevo. Todo combinado.',

  hud_tap_to_breach: '▾  toca un nodo para perforar  ▾',
  hud_tap_to_skip: "saltar  ▸▸",
  hud_drag_zoom_help: 'arrastra para mover · rueda/pellizco para zoom',
  hud_required: 'REQUERIDO',
  hud_core_online: 'NÚCLEO ACTIVO',
  hud_core_down: 'NÚCLEO CAÍDO',

  tut_tap_any_node: 'TOCA CUALQUIER NODO',
  tut_they_all_work: 'todos funcionan aquí',

  brief_eyebrow: '◂ MISIÓN ▸',
  brief_title: 'UN TOQUE.\nUNA CASCADA.',
  brief_line_1: '› Tienes exactamente UN toque.',
  brief_line_2: '› Activa una reacción en cadena en la red.',
  brief_line_3: '› Colapsa cada REQUERIDO (diamante cian) para ganar.',
  brief_line_4: '› Nunca dejes que un pulso toque PROTEGIDO (rojo).',
  brief_begin: '› INICIAR MISIÓN ‹',

  result_win_headline: 'SISTEMA COLAPSADO',
  result_fail_headline: 'CASCADA FALLIDA',
  result_first_clear: '› PRIMER LOGRO ‹',
  result_try_label: '› INTENTA',
  result_cleared_suffix: 'COMPLETADO',
  result_aborted_suffix: 'EJECUCIÓN ABORTADA',
  result_win_body_template: '{ticks} ticks. {nodes} nodos caídos.',

  fail_protected_overload: 'Nodo protegido sobrecargado. La cascada tocó algo que no debía.',
  fail_forbidden_trigger: 'Una línea prohibida transmitió señal. Disparó una alarma dura.',
  fail_required_not_reached: 'Un nodo requerido nunca recibió pulso. La cadena no lo alcanzó.',
  fail_required_under_threshold: 'Un requerido no recibió suficientes pulsos. La descarga mató al primero antes del segundo.',
  fail_core_not_collapsed: 'El núcleo sobrevivió. La cascada se disipó antes de llegar.',
  fail_core_under_threshold: 'El núcleo recibió pulsos, pero no suficientes, no convergieron a tiempo.',
  fail_core_shielded: 'Pulsos del núcleo bloqueados. Un escudo seguía activo.',
  fail_chain_died: 'La cadena murió antes de alcanzar nada.',
  fix_protected_overload: 'Elige un iniciador cuya cascada nunca llegue al peligro rojo. Traza primero las salidas de cada iniciador.',
  fix_forbidden_trigger: 'Evita iniciadores que disparen HACIA un cable rojo a trazos. La alarma se activa al instante.',
  fix_required_not_reached: 'Tu iniciador no conecta con ese nodo. Mira las flechas, los cables direccionales solo fluyen en un sentido.',
  fix_required_under_threshold: 'Busca una ruta que entregue dos pulsos a ese nodo, un divisor o dos caminos convergentes suele bastar.',
  fix_core_not_collapsed: 'Necesitas más convergencia hacia el núcleo. Divisores, capacitores y relés existen para alimentarlo.',
  fix_core_under_threshold: 'Los pulsos llegan demasiado lentos. Usa divisores para apilar impactos, o haz que todos lleguen en el mismo tick.',
  fix_core_shielded: 'Tira cada escudo antes de cualquier disparo letal. Un cable de retraso que llega tarde es una forma limpia.',
  fix_chain_died: 'Tu iniciador solo conecta con un nodo. Elige uno en el centro de la red.',

  popup_new_node: '◂ NUEVO TIPO DE NODO ▸',
  popup_new_wire: '◂ NUEVO TIPO DE CABLE ▸',

  node_normal_title: 'NODO',
  node_normal_tagline: 'La unidad base. Tócalo para iniciar una cascada.',
  node_normal_b1: 'Colapsa con el primer pulso que llega.',
  node_normal_b2: 'Dispara un pulso en cada cable saliente abierto.',
  node_normal_b3: 'Sin umbral, un golpe y desaparece.',

  node_required_title: 'REQUERIDO',
  node_required_tagline: 'Debes colapsar cada REQUERIDO para ganar.',
  node_required_b1: 'Diamante cian. Pulsa suavemente en reposo para que lo veas.',
  node_required_b2: 'Algunos necesitan 2+ pulsos llegando en la misma ventana.',
  node_required_b3: 'Falla uno solo y la ejecución termina.',
  node_required_note: 'Un pequeño anillo de puntos muestra su progreso de carga.',

  node_protected_title: 'PROTEGIDO',
  node_protected_tagline: 'Tócalo y toda la ejecución muere.',
  node_protected_b1: 'Cruz roja de peligro. Marcado con corchetes en las esquinas.',
  node_protected_b2: 'Cualquier pulso aquí provoca un FALLO instantáneo.',
  node_protected_b3: 'Planea una ruta que nunca lo alimente.',

  node_relay_title: 'RELÉ',
  node_relay_tagline: 'Abre cables bloqueados al colapsar.',
  node_relay_b1: 'Galón dorado. Sus objetivos son cables BLOQUEADOS a trazos.',
  node_relay_b2: 'Cuando el relé cae, sus cables bloqueados se encienden.',
  node_relay_b3: 'Útil para revelar una ruta a un nodo protegido.',

  node_shield_title: 'ESCUDO',
  node_shield_tagline: 'Guardaespaldas. Absorbe golpes por otro nodo.',
  node_shield_b1: 'Anillo hexagonal verde alrededor del nodo protegido.',
  node_shield_b2: 'Un pulso directo a un nodo escudado NO HACE NADA.',
  node_shield_b3: 'Colapsa el escudo primero, luego entrega el golpe.',
  node_shield_note: 'Los cables de RETRASO (dorado a trazos) sirven para sincronizar un golpe post-escudo.',

  node_splitter_title: 'DIVISOR',
  node_splitter_tagline: 'Multiplica pulsos en todas sus salidas.',
  node_splitter_b1: 'Tridente magenta. Un pulso entra → N pulsos por salida.',
  node_splitter_b2: 'La marca X muestra su factor de división.',
  node_splitter_b3: 'Suministra los múltiples impactos que necesita un NÚCLEO.',

  node_capacitor_title: 'CAPACITOR',
  node_capacitor_tagline: 'Almacena un pulso y lo re-emite, un búfer.',
  node_capacitor_b1: 'Símbolo de capacitor amarillo. Reenvía un pulso 3 ticks después.',
  node_capacitor_b2: 'Trátalo como un RETRASO incorporado en la ruta.',
  node_capacitor_b3: 'Permite que un pulso posterior llegue DESPUÉS de caer un escudo.',

  node_core_title: 'NÚCLEO',
  node_core_tagline: 'El objetivo. Umbral alto, decaimiento rápido.',
  node_core_b1: 'Reactor púrpura. Necesita muchos pulsos convergentes para caer.',
  node_core_b2: 'La carga DECAE, los pulsos deben llegar muy juntos.',
  node_core_b3: 'A menudo guardado por escudos. Tíralos, luego inunda el núcleo.',
  node_core_note: 'Un nivel con NÚCLEO se gana colapsándolo. Los requeridos (si los hay) también cuentan.',

  wire_directional_title: 'CABLE DIRECCIONAL',
  wire_directional_tagline: 'Conductor unidireccional. Cian con punta de flecha.',
  wire_directional_b1: 'El pulso solo viaja en la dirección de la flecha.',
  wire_directional_b2: 'Toca el lado equivocado de la flecha y nada fluye.',
  wire_directional_b3: 'Sigue las flechas desde tu iniciador hasta el final.',

  wire_delay_title: 'CABLE DE RETRASO',
  wire_delay_tagline: 'Dorado a trazos. El pulso llega 3 ticks después.',
  wire_delay_b1: 'Útil para sincronizar, golpea DESPUÉS de caer un escudo.',
  wire_delay_b2: 'O para apilar dos pulsos en un nodo de umbral alto.',
  wire_delay_b3: 'Falla el tiempo y el primer pulso decaerá antes.',

  wire_locked_title: 'CABLE BLOQUEADO',
  wire_locked_tagline: 'Gris a trazos + candado. Cerrado hasta que algo lo abra.',
  wire_locked_b1: 'Un RELÉ controla cada cable bloqueado.',
  wire_locked_b2: 'Cuando el relé colapsa, sus cables bloqueados se abren.',
  wire_locked_b3: 'No malgastes un toque intentando alimentar uno directamente.',

  wire_forbidden_title: 'CABLE PROHIBIDO',
  wire_forbidden_tagline: 'ROJO a trazos con cruz. Tocarlo = fallo instantáneo.',
  wire_forbidden_b1: 'Cualquier pulso, incluso de paso, activa la alarma.',
  wire_forbidden_b2: 'Vigila estos en las salidas de cada iniciador.',
  wire_forbidden_b3: 'Elige un iniciador cuya ruta NUNCA toque rojo.',

  wire_burn_title: 'CABLE INCENDIARIO',
  wire_burn_tagline: 'Naranja latón. Un solo uso, se quema tras un pulso.',
  wire_burn_b1: 'Lleva exactamente UN pulso y muere para siempre.',
  wire_burn_b2: 'Planea su uso único con cuidado, no hay segunda oportunidad.',
  wire_burn_b3: 'Una vez quemado, ninguna cascada puede atravesarlo.',

  callout_required_crashed: 'REQUERIDO CAÍDO',
  callout_core_breached: 'NÚCLEO PERFORADO',
  callout_shield_dropped: 'ESCUDO CAÍDO',
  callout_relay_opened: 'RELÉ ABIERTO',
  callout_protected_hit: 'PROTEGIDO IMPACTADO',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: 'Tu toque',
  result_map_broke: 'Falló aquí',
  result_map_answer: 'Funciona',
  result_show_answer: 'Mostrar la respuesta',
  menu_endless_line: 'Niveles generados con tres vidas. Cuanto más profundo, más duro muerde.',
  menu_best: 'Mejor LV {n}',
  menu_best_streak: 'Mejor LV {n}  ·  racha ×{s}',
  menu_resume: 'Continuar LV {n}',
  menu_start: 'Empezar LV 1',
  result_run_total: 'Total de la partida {n}',
  result_streak: 'Racha ×{n}',
  result_streak_wins: '{n} victorias seguidas',
  legend_title: 'Leyenda',
  legend_nodes: 'NODOS',
  legend_wires: 'CABLES',
  legend_close: 'Toca en cualquier lugar para cerrar',
  settings_sync_now: 'Sincronizar ({who})',
  settings_sign_in: 'Inicia sesión para sincronizar',
  settings_sign_out: 'Cerrar sesión',

};
